<div class="media-mgmt-group">
  <div class="group" [hidden]="!isHasAccess">
    <div
      class="header-group"
      fxLayout="row"
      fxLayoutAlign="space-between center">
      <div fxLayout="row">
        <div>
          <span class="title-header">Media Broadcast</span>
          <sup
            ><i
              *ngIf="!isNewWindow"
              class="fa fa-window-restore open-window"
              (click)="openWindow()"></i
          ></sup>
        </div>
      </div>
    </div>
    <div class="subtitle" fxLayout="row" fxLayoutAlign="space-between center">
      <span>Vehicle Video Status</span>
    </div>
    <div class="list custom-page-scroll" fxLayout="column">
      <table
        #vehicleStatus="matSort"
        mat-table
        [dataSource]="deviceDataSource"
        matSort
        class="content-table">
        <ng-container
          *ngFor="let columnName of deviceDisplayedColumns; let idx = index"
          [matColumnDef]="columnName">
          <ng-container [ngSwitch]="columnName">
            <ng-container *ngSwitchDefault>
              <th
                mat-header-cell
                *matHeaderCellDef
                class="content-header"
                mat-sort-header
                disableClear>
                <div>
                  {{ deviceColumnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
            <ng-container *ngSwitchCase="'Actions'">
              <th mat-header-cell *matHeaderCellDef class="content-header">
                <div>
                  {{ deviceColumnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
          </ng-container>
          <ng-container>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="columnName">
                <ng-container *ngSwitchDefault>{{
                  element[columnName]
                }}</ng-container>
                <!-- <ng-container *ngSwitchCase="'downloadStatus'">{{
                  element[columnName] ? 'Downloaded' : 'Not Downloaded'
                }}</ng-container> -->
                <ng-container *ngSwitchCase="'videoFileSize'">
                  {{ element[columnName] | filesize }}
                </ng-container>
                <ng-container *ngSwitchCase="'updatedAt'">
                  {{
                    (element[columnName] | momentPipe: 'DD/MM/YYYY HH:mm') ?? ''
                  }}
                </ng-container>
                <ng-container *ngSwitchCase="'Actions'">
                  <button
                    [matTooltip]="
                      element?.['buttonStatus'] === 'stop'
                        ? 'Play Video'
                        : 'Stop Video'
                    "
                    mat-icon-button
                    [disabled]="deviceLoading"
                    (click)="onPlay(element)">
                    <mat-icon *ngIf="element?.['buttonStatus'] === 'stop'"
                      >play_arrow</mat-icon
                    >
                    <mat-icon *ngIf="element?.['buttonStatus'] === 'start'"
                      >stop</mat-icon
                    >
                  </button>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="deviceDisplayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: deviceDisplayedColumns; let entry"
          class="content-row"></tr>
      </table>
      <div class="content-loading" *ngIf="deviceLoading">
        <mat-spinner class="margin-auto"></mat-spinner>
      </div>
    </div>
    <div>
      <mat-paginator
        #devicePaginator
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[1, 10, 15, 25, 50, 100]"></mat-paginator>
    </div>
    <div class="subtitle" fxLayout="row" fxLayoutAlign="space-between center">
      <span>Video List</span>
      <button mat-raised-button type="button" (click)="openUploadModal()">
        Upload
      </button>
    </div>
    <div class="list custom-page-scroll" fxLayout="column">
      <table
        #mediatable="matSort"
        mat-table
        [dataSource]="dataSource"
        matSort
        class="content-table">
        <ng-container
          *ngFor="let columnName of displayedColumns; let idx = index"
          [matColumnDef]="columnName">
          <ng-container [ngSwitch]="columnName">
            <ng-container *ngSwitchDefault>
              <th
                mat-header-cell
                *matHeaderCellDef
                class="content-header"
                mat-sort-header
                disableClear>
                <div>
                  {{ columnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
            <ng-container *ngSwitchCase="'Actions'">
              <th mat-header-cell *matHeaderCellDef class="content-header">
                <div>
                  {{ columnList | getById: columnName : 'name' }}
                </div>
              </th>
            </ng-container>
          </ng-container>
          <ng-container>
            <td mat-cell *matCellDef="let element">
              <ng-container [ngSwitch]="columnName">
                <ng-container *ngSwitchDefault>{{
                  element[columnName]
                }}</ng-container>
                <ng-container *ngSwitchCase="'videoFileSize'">
                  {{ element[columnName] | filesize }}
                </ng-container>
                <ng-container *ngSwitchCase="'createdAt'">
                  {{
                    (element[columnName] | momentPipe: 'DD/MM/YYYY HH:mm') ?? ''
                  }}
                </ng-container>
                <ng-container *ngSwitchCase="'flagPlay'">
                  <!-- <mat-checkbox
                    type="checkbox"
                    [checked]="element.flagPlay"
                    [disabled]="element.flagPlay"
                    (change)="onCheckChange($event.checked, element, 'flag')">
                    {{ element.flagPlay ? 'Yes' : 'No' }}
                  </mat-checkbox> -->
                  {{ element[columnName] ? 'Active' : 'Inactive' }}
                </ng-container>
                <ng-container *ngSwitchCase="'Actions'">
                  <button
                    matTooltip="Set Active"
                    mat-icon-button
                    [disabled]="isLoading || element?.['flagPlay']"
                    (click)="setActive(element)">
                    <mat-icon>check</mat-icon>
                  </button>
                  <button
                    matTooltip="Delete Video"
                    mat-icon-button
                    [disabled]="isLoading"
                    (click)="onDelete(element)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </ng-container>
              </ng-container>
            </td>
          </ng-container>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns; let entry"
          [ngClass]="{ 'active-video': entry.flagPlay }"
          class="content-row"></tr>
      </table>
      <div class="content-loading" *ngIf="isLoading">
        <mat-spinner class="margin-auto"></mat-spinner>
      </div>
    </div>
    <div>
      <mat-paginator
        #mediapaginator
        [pageIndex]="0"
        [pageSize]="10"
        [pageSizeOptions]="[1, 10, 15, 25, 50, 100]"></mat-paginator>
    </div>
  </div>
</div>
